// src/Redux/app/slice/filesTableSlice.js (Complete Replacement)

import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
// NOTE: axios import is removed as it is no longer used directly here.

// --- FIX 1: Import the correct API function ---
import { 
    deleteFile, 
    downloadPdfApi,
    downloadPdfXlsxApi,
    downloadOriginalPdfApi, // *** NEW API FUNCTION IMPORT ***
    getFilesData, 
    sampleInferIQApi, 
    upodateJsonFileData, 
    UploadPdfApi 
} from "../../../Services/API";
import { pageSize } from "../../../Utils/constants";

// This thunk is correct and remains unchanged.
export const getFileTable = createAsyncThunk("filessSlice", async (data) => {
    try {
        const response = await getFilesData(data);
        return response;
    } catch (error) {
        throw error;
    }
});

// ======================= THE FINAL CORRECTED THUNK =======================
export const uploadFileSlice = createAsyncThunk(
    'files/uploadFile',
    async ({ formData, queryParams }, { rejectWithValue }) => {
        try {
            const response = await UploadPdfApi({ formData, queryParams });
            return response.data;
        } catch (error) {
            console.error("Upload API Error:", error.response || error);
            return rejectWithValue({
                status: error.response?.status,
                data: error.response ? error.response.data : error.message,
            });
        }
    }
);
// ======================= END OF CORRECTION =======================

// All other thunks are correct and remain unchanged.
export const downloadPdfSlice = createAsyncThunk("downloadPdfSlice", async (data) => {
    try {
        const response = await downloadPdfApi(data);
        return response;
    } catch (error) {
        throw error;
    }
});

// *** NEW THUNK: For viewing the original PDF - Corresponds to GET /pdf/{id}/original-pdf ***
export const downloadOriginalPdfSlice = createAsyncThunk("downloadOriginalPdfSlice", async (id) => {
    try {
        // Assuming downloadOriginalPdfApi is the new function that calls the /pdf/{id}/original-pdf endpoint
        const response = await downloadOriginalPdfApi(id); 
        return response;
    } catch (error) {
        throw error;
    }
});

export const downloadExcelSlice = createAsyncThunk("downloadExcelSlice", async (id) => {
  try {
    const response = await downloadPdfXlsxApi(id);
    
    // SAFE CHECK: 
    // If 'response' has a .data property, use it. 
    // Otherwise, 'response' IS the data.
    const payload = response?.data || response;
    
    return payload; 
  } catch (error) {
    throw error;
  }
});

export const pdfextractData = createAsyncThunk("pdfextractData", async (data) => {
    try {
        const response = await sampleInferIQApi(data);
        return response;
    } catch (error) {
        throw error;
    }
});

export const updateFileJson = createAsyncThunk("updateFileJson", async (data) => {
    try {
        const response = await upodateJsonFileData(data);
        return response;
    } catch (error) {
        throw error;
    }
});

export const fileDeleteSlice = createAsyncThunk("fileDeleteSlice", async (data) => {
    try {
        const response = await deleteFile(data, data.header);
        return response;
    } catch (error) {
        throw error;
    }
});

// Your initial state is preserved exactly as it was.
const initialState = {
    search: "",
    tableData: [],
    page: 1,
    status: "",
    totalPages: 0,
    totalCount: 0,
    caseNumber: null,
    startDate: "",
    pageSize: pageSize,
    endDate: "",
    loading: false,
    pagination: {},
    sortBy: "",
    sortOrder: "",
    selectedCase: "",
    sampleInferData: [],
    updatess: [],
    apiresponse: null,
    documentType: "",
    error: null,
    data: null,
};

// Your slice, reducers, and extraReducers are preserved.
export const fileTable = createSlice({
    name: "fileTable",
    initialState,
    reducers: {
        setPage: (state, action) => {
            state.page = action.payload;
        },
        setSearch: (state, action) => {
            state.search = action?.payload;
        },
        setSortBy: (state, action) => {
            state.sortBy = action?.payload;
        },
        setPagesize: (state, action) => {
            state.pageSize = action.payload;
        },
        setSortOrder: (state, action) => {
            state.sortOrder = action?.payload;
        },
        setDateGlobal: (state, action) => {
            state.startDate = action?.payload?.formattedStartDate;
            state.endDate = action?.payload?.formattedEndDate;
        },
        setStatus: (state, action) => {
            state.status = action?.payload
        },
        setCaseId: (state, action) => {
            state.caseNumber = action?.payload
        },
        setDocumentType: (state, action) => {
            state.documentType = action?.payload
        },
        setSelectedCase: (state, action) => {
            state.selectedCase = action?.payload
        },
        reset: () => initialState
    },
    extraReducers: (builder) => {
        builder.addCase(getFileTable.pending, (state) => {
            state.loading = true;
        }).addCase(getFileTable.fulfilled, (state, action) => {
            state.loading = false;
            state.tableData = action?.payload?.data;
            state.totalPages = action?.payload?.data?.data?.pagination?.totalPages
            state.pagination = action?.payload?.data?.data?.pagination
        }).addCase(getFileTable.rejected, (state, action) => {
            state.loading = false;
            state.error = action?.payload;
        }).addCase(downloadPdfSlice.pending, (state) => {
            state.loading = true;
        }).addCase(downloadPdfSlice.fulfilled, (state, action) => {
            state.loading = false;
            state.data = action.payload;
        }).addCase(downloadPdfSlice.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        })
        // *** NEW REDUCERS: For downloadOriginalPdfSlice ***
        .addCase(downloadOriginalPdfSlice.pending, (state) => {
            state.loading = true;
        }).addCase(downloadOriginalPdfSlice.fulfilled, (state, action) => {
            state.loading = false;
            state.data = action.payload; // Store the presigned URL response
        }).addCase(downloadOriginalPdfSlice.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        })
        // *** END NEW REDUCERS ***
        .addCase(uploadFileSlice.pending, (state) => {
            state.loading = true;
        }).addCase(uploadFileSlice.fulfilled, (state, action) => {
            state.loading = false;
            state.data = action.payload;
        }).addCase(uploadFileSlice.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        }).addCase(pdfextractData.pending, (state) => {
            state.loading = true;
        }).addCase(pdfextractData.fulfilled, (state, action) => {
            state.page = action?.payload?.data?.pagination?.page;
            state.totalCount = action?.payload?.data?.pagination?.totalCount;
            state.loading = false;
            state.sampleInferData = action?.payload?.data?.inferIQData[0]?.data;
            state.updatess = action?.payload?.data?.updated;
            state.apiresponse = action?.payload?.data?.apiresponse;
        }).addCase(pdfextractData.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        }).addCase(updateFileJson.pending, (state) => {
            state.loading = true;
        }).addCase(updateFileJson.fulfilled, (state, action) => {
            state.loading = false;
            state.data = action?.payload?.data;
            state.updatess = [action?.payload?.data?.updated];
        }).addCase(updateFileJson.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        }).addCase(fileDeleteSlice.pending, (state) => {
            state.loading = true;
        }).addCase(fileDeleteSlice.fulfilled, (state, action) => {
            state.loading = false;
            state.tableData = state.tableData.filter(file => file.sequence !== action.payload.data.sequence);
            state.caselogindetail = action.payload;
        }).addCase(fileDeleteSlice.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        })
    }
})

// Your exports are preserved exactly as they were.
export const { setPage, setSearch, reset, setSelectedCase, setPagesize, setDateGlobal, setStatus, setCaseId, setDocumentType, setSortBy, setSortOrder } = fileTable.actions;
export default fileTable.reducer;
